module.exports = __webpack_public_path__ + "133d16cba4220d74754ca756ba4c9bd2.png";